import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const agencyWhiteLabelTemplate: FunnelTemplate = {
  id: "agency-white-label",
  serviceLine: "white-label",
  recommendedBands: ["growth"],
  pdfAccentColor: "#2563eb",
  defaultTrafficChannels: [
    { id: "google_organic",   label: "Google Organic",   monthlyVisitors: 600, acquisitionType: "organic" },
    { id: "linkedin",         label: "LinkedIn",          monthlyVisitors: 200, acquisitionType: "organic" },
    { id: "email_newsletter", label: "Email Newsletter",  monthlyVisitors: 150, acquisitionType: "organic" },
    { id: "referral",         label: "Referral",          monthlyVisitors: 50,  acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "awareness",     conversionRate: 100, isEditable: false, stageType: "blog-post" },
    { id: "website-visit", conversionRate: 3.5, isEditable: true,  stageType: "landing-page" },
    { id: "lead",          conversionRate: 8,   isEditable: true,  stageType: "opt-in-page" },
    { id: "discovery",     conversionRate: 40,  isEditable: true,  stageType: "discovery-call" },
    { id: "proposal",      conversionRate: 60,  isEditable: true,  stageType: "proposal" },
    { id: "close",         conversionRate: 35,  isEditable: true,  stageType: "retainer-close" },
  ],
};
